import { deleteDuplicates } from '@shared/utils';
import { trpc } from '@web/lib/trpc';
import { useEffect, useMemo } from 'react';

export function useContacts() {
  const {
    messaging: { getContacts: getContactsUtils },
  } = trpc.useUtils();

  const {
    data: contactsData,
    fetchNextPage: fetchMoreContacts,
    fetchPreviousPage: fetchRecentContacts,
  } = trpc.messaging.getContacts.useInfiniteQuery(
    {},

    {
      getPreviousPageParam: (firstPage) => ({
        dateFrom: firstPage.at(0)?.lastMessageDate ?? undefined,
      }),

      getNextPageParam: (lastPage) => ({
        dateTo: lastPage.at(-1)?.lastMessageDate ?? undefined,
      }),
    },
  );

  const contacts = useMemo(
    () =>
      deleteDuplicates(contactsData?.pages.flat() ?? [], ({ id }) => id).sort(
        (a, b) => b.lastMessageDate - a.lastMessageDate,
      ),
    [contactsData],
  );

  useEffect(() => {
    getContactsUtils.setInfiniteData(
      {},
      {
        pageParams: [
          {
            dateTo: contacts.at(0)?.lastMessageDate ?? undefined,
            dateFrom: contacts.at(-1)?.lastMessageDate ?? undefined,
          },
        ],
        pages: [contacts],
      },
    );
  }, [contacts, getContactsUtils]);

  return {
    contacts,
    fetchRecentContacts,
    fetchMoreContacts,
  };
}
